
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import TableModalArea from "./table-modal-area.vue";
import FilterModalArea from "./filter-modal-area.vue";
import { GeoAddress, ManageArea } from "@/domain/entities/ManageArea";
import { ListGeoAddressApiRequest } from "@/data/payload/api/ManageAreaApiRequest";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { ManageAreaController } from "@/app/ui/controllers/ManageAreaController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
    required: true
  });
  data = prop<ManageArea>({
    default: () => new ManageArea(),
    type: Object,
    required: true
  });
}

@Options({
  components: {
    OverlayPanel,
    TableModalArea,
    FilterModalArea
  },
  watch: {
    modelValue(newVal: boolean) {
      if (newVal) this.init();
    }
  }
})
export default class ModalGeoAddress extends Vue.with(Props) {
  get visible() {
    return this.modelValue;
  }
  set visible(val: boolean) {
    this.$emit("update:modelValue", val);
  }

  init() {
    this.params = new ListGeoAddressApiRequest();
    this.getList();
  }

  get isFiltering() {
    return Boolean(this.params.q);
  }

  onFilter() {
    this.params.pagination.page = 1;
    this.getList();
  }

  get column(): any {
    return [
      {
        name: "No",
        style: {
          width: "50px",
          textAlign: "center"
        },
        slotName: "no"
      },
      {
        name: "Kelurahan",
        orderBy: "village_name",
        class: "w-1/5",
        render: (item: GeoAddress) =>
          `<div class="flex items-start text-sm text-black-lp-300">${item.villageName}</div>`
      },
      {
        name: "Kecamatan",
        orderBy: "sub_district_name",
        class: "w-1/5",
        render: (item: GeoAddress) =>
          `<div class="flex items-start text-sm text-black-lp-300">${item.subDistrictName}</div>`
      },
      {
        name: "Kota/Kabupaten",
        orderBy: "district_name",
        class: "w-1/5",
        render: (item: GeoAddress) =>
          `<div class="flex items-start text-sm text-black-lp-300">${item.districtName}</div>`
      },
      {
        name: "Provinsi",
        orderBy: "province_name",
        class: "w-1/5",
        render: (item: GeoAddress) =>
          `<div class="flex items-start text-sm text-black-lp-300">${item.provinceName}</div>`
      },
      {
        name: "Tipe Shipment",
        class: "w-1/5",
        render: (item: GeoAddress) =>
          `<div class="flex items-start text-sm text-black-lp-300">${item.dedicatedShipment}</div>`
      }
    ];
  }

  get offset() {
    return this.params.pagination.limit * (this.params.pagination.page - 1);
  }

  params = new ListGeoAddressApiRequest();
  listData = new ResponsePayloadV2();
  async getList() {
    try {
      this.listData = new ResponsePayloadV2({
        loading: true
      });

      const res = await ManageAreaController.getGeoAddress(
        new ListGeoAddressApiRequest({ ...this.params, areaUid: this.data.uid })
      );
      this.listData.data = res.data;
      this.params.pagination = res.pagination;
    } catch (err) {
      this.listData.errorType = parsingErrorResponse(err).type;
    } finally {
      this.listData.loading = false;
    }
  }
}
